module.exports = __webpack_public_path__ + "img/AMUR.1a3cd855.png";